export const apiPaginationConverter = (page = 0, perPage) => {
    const limit = perPage;
    const offset = page * perPage;

    return {limit, offset}
};